<!-- https://8es9hr.axshare.com/#g=1&p=%E7%8F%BE%E9%87%91%E6%94%B6%E6%AC%BE%E4%BD%9C%E6%A5%AD -->
<!-- 現金收款作業 -->
<template>
	<div class="row">
		<div class="col-12">
			<div class="mb10">
				<el-button type="primary" plain @click="go('cabinet_edit')"
					>回社員首頁</el-button
				>
				<el-button type="danger" plain @click="go('cabinet_search')"
					>搜尋其他社員</el-button
				>
			</div>
			<div class="col-block" v-if="this.$route.query.title !== 'report'">
				<div class="block-header has-border">
					<h3>
						<strong>
							{{ memberMain.account + " " + memberMain.name }}
						</strong>
					</h3>
					&emsp;
					<h3>
						<strong>現金收款作業</strong>
					</h3>
					<el-button class="ml10" plain @click="openAddWork"
						>新增收款對象</el-button
					>

					<div class="mt10">
						<h3>
							<strong>收款日期</strong>
						</h3>

						<span class="date ml10">
							<input
								type="text"
								name="mingo"
								:class="`min_go_date_select`"
								placeholder="選擇日期"
								ref="datepicker"
							/>
							<span
								class="el-input__prefix"
								style="margin-left: 5px"
							>
								<i class="el-icon-date"></i>
							</span>
						</span>
					</div>
				</div>
				<div class="block-content">
					<!-- 收款對象 -->
					<el-card
						class="box-card"
						v-for="(work, workIndex) in works"
						:key="workIndex"
					>
						{{ work.account + " " + work.name }}
						<table class="table table-bordered mb-0 mt10">
							<thead class="grey lighten-4">
								<tr>
									<th>會計科目</th>
									<th>金額</th>
									<th>摘要</th>
									<th></th>
									<th></th>
								</tr>
							</thead>
							<tbody>
								<tr
									v-for="(content, itemIndex) in work.content"
									:key="itemIndex"
								>
									<td>{{ content.name }}</td>
									<td
										v-show="content.display"
										:rowspan="content.rowspan"
									>
										<el-input
											v-model="content.amount"
											:disabled="content['disabled']"
											v-if="content.judegeKey !== 2"
											v-on:input="
												resetAmount(
													content.amount,
													workIndex,
													itemIndex
												)
											"
										></el-input>
										<el-input
											v-model="content.amount"
											:disabled="content['disabled']"
											@change="
												(v) => {
													test(
														content.amount,
														workIndex,
														itemIndex
													);
												}
											"
											v-on:input="
												resetAmount(
													content.amount,
													workIndex,
													itemIndex
												)
											"
											v-else
										></el-input>
									</td>
									<td>{{ content.note }}</td>
									<td
										v-show="content.display"
										:rowspan="content.rowspan"
									>
										<el-button
											type="primary"
											plain
											v-if="content.type === 2"
											@click="
												resetDate(workIndex, itemIndex)
											"
											>還款試算</el-button
										>
									</td>
									<td
										v-show="content.display"
										:rowspan="content.rowspan"
									>
										<el-button
											type="danger"
											plain
											@click="
												removeItem(
													workIndex,
													itemIndex,
													content.isRepayment
												)
											"
											>移除項目</el-button
										>
									</td>
								</tr>
								<tr>
									<td>小計</td>
									<td>{{ totalPayment(work) }}</td>
									<td></td>
									<td></td>
									<td></td>
								</tr>
							</tbody>
						</table>
						<div class="mt10">
							<el-button
								class="mr10"
								plain
								@click="openAddItem(work, workIndex)"
								>新增收款項目</el-button
							>
							<el-button
								class="mr10"
								type="danger"
								plain
								v-if="work.need"
								@click="removeMember(workIndex)"
								>移除收款對象</el-button
							>
						</div>
						<!-- 中文詞彙 插入 -->
						<h3>備註</h3>
						<el-select
							class="el-select ml10 mt10"
							placeholder="中文詞彙"
							v-model="works[workIndex].Glossary"
						>
							<el-option
								:value="item.value"
								:label="item.label"
								v-for="(item, index) in GlossaryList"
								:key="index"
							></el-option>
						</el-select>

						<el-button
							type="primary"
							plain
							class="ml10"
							@click="importGlossary(workIndex)"
							>插入</el-button
						>
						<el-input
							class="mt10"
							type="textarea"
							:rows="4"
							v-model="works[workIndex].remark"
							placeholder="請輸入內容"
						></el-input>
					</el-card>
					<h3>
						共 {{ works.length }} 張 收款單 金額總計：{{
							allMemberTotalPayment()
						}}
					</h3>
					<el-button type="primary" class="ml10" plain @click="submit"
						>確認收款並列印收款單</el-button
					>
					<el-button class="ml10" plain @click="back">返回</el-button>
				</div>
				<!-- 新增收款對象 -->
				<el-dialog
					custom-class="member-group"
					title="新增收款對象"
					:visible.sync="dialogAddWork"
					:append-to-body="true"
					width="300px"
				>
					<ListForm
						api="member"
						:recordToEdit="addMemberObj"
						:filter="memberFilter"
						labelPosition="top"
						:formType="formType"
					>
						<div slot="footer" class="dialog-footer"></div>
					</ListForm>
					<div slot="footer" class="dialog-footer">
						<el-button @click="dialogAddWork = false"
							>取消</el-button
						>
						<el-button type="primary" @click="saveAddWork"
							>確定</el-button
						>
					</div>
				</el-dialog>
				<!-- 新增收款項目 -->
				<el-dialog
					:visible.sync="dialogAddItem"
					:append-to-body="true"
					width="370px"
				>
					<el-form label-position="top">
						<el-form-item label="收款項目">
							<el-select
								placeholder="請選擇類別"
								v-model="currentAddItem.type"
								style="width: 100%"
								@change="
									chooseType(
										currentAddItem,
										currentIndex,
										null,
										true
									)
								"
							>
								<el-option
									v-for="item in options"
									:key="item.value"
									:label="item.label"
									:value="item.value"
								></el-option>
							</el-select>
							<el-select
								placeholder="請選擇方案"
								class="mt10"
								:filterable="true"
								v-model="currentAddItem.chooseRepayment"
								@change="
									(val) => {
										getAmount(currentAddItem);
									}
								"
								v-if="showSelect"
							>
								<el-option
									v-for="option of currentAddItem.iouList"
									:key="option.id"
									:label="
										currentAddItem.type === 2
											? `${option.iouNumber}`
											: currentAddItem.type === 5
											? `${option.label}`
											: option.label
									"
									:value="
										currentAddItem.type === 2
											? `${option.iouNumber}`
											: currentAddItem.type === 5
											? `${option.value}`
											: currentAddItem.type == 3
											? option
											: option.value
									"
								></el-option>
							</el-select>
							<el-select
								placeholder="請選擇年度"
								class="mt10"
								:filterable="true"
								v-model="currentAddItem.selectYear"
								@change="
									(val) => {
										getAmount(currentAddItem);
									}
								"
								v-show="currentAddItem.type == 7"
							>
								<el-option
									v-for="option of yearList"
									:key="option.value"
									:label="option.label"
									:value="option.value"
								></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="金額">
							<el-input
								v-model="currentAddItem.amount"
								:disabled="inputDsabled"
								v-on:input="
									resetAddAmount(currentAddItem.amount)
								"
							></el-input>
						</el-form-item>
						<el-form-item label="摘要">
							<el-input
								type="textarea"
								v-model="currentAddItem.note"
							></el-input>
						</el-form-item>
					</el-form>
					<div slot="footer" class="dialog-footer">
						<el-button @click="dialogAddItem = false"
							>取消</el-button
						>
						<el-button
							type="primary"
							@click="
								saveAddItem(currentAddItem, currentIndex, true)
							"
							>確定</el-button
						>
					</div>
				</el-dialog>
				<!-- 還款試算 -->
				<el-dialog
					:visible.sync="loanModal"
					:append-to-body="true"
					:close-on-click-modal="false"
				>
					<div slot="title">
						<p
							class="fs15"
							style="display: inline-block; margin-right: 10px"
						>
							{{ loanIouNumber }} 還款
							<el-button
								type="primary"
								plain
								@click="
									showRepaymentInfo(
										currentIndex,
										loanRowIndex
									)
								"
								class="mr10"
								>變更日期</el-button
							>
							<span class="mt10">
								<input
									type="text"
									name="mingo"
									class="min_go_date changeDate"
									placeholder="選擇日期"
								/>
								<span class="el-input__prefix"></span>
							</span>
						</p>
					</div>
					<div>
						<p class="fs15">
							每期應還金額: {{ $addcomma(iouObj.stageLoanPay) }}
						</p>
						<p class="fs15">
							上次償還日期: {{ iouObj.lastPayDate | datechange }}
						</p>
						<p class="fs15">
							剩餘本金: {{ $addcomma(iouObj.loanPriceBeforePay) }}
						</p>
						<p class="fs15">
							當下利率: {{ iouObj.normalAnnualRate }}
						</p>
						<p class="fs15">
							還款寬限日: {{ iouObj.securedGraceDay }}
						</p>
						<p class="fs15">違約金利率: {{ iouObj.loanPenalty }}</p>
						<p class="fs15">
							前欠利息:
							{{ $addcomma(iouObj.interestNotPayBefore) }}
						</p>
						<p class="fs15">
							前欠違約金:
							{{ $addcomma(iouObj.breakNotPayBefore) }}
						</p>
						<p class="fs15">
							應還利息減免金額:
							{{ $addcomma(iouObj.interestAmountReduction) }}
						</p>
						<p class="fs15">
							應還違約金減免金額:
							{{ $addcomma(iouObj.breakAmountReduction) }}
						</p>

						<p class="fs15">
							應繳本金:
							{{ $addcomma(iouObj.payBackLoanPrice) }}
						</p>
						<p class="fs15">
							應繳利息(含前欠):
							{{ $addcomma(iouObj.payBackInterest) }}
						</p>
						<p class="fs15">
							應繳違約金(含前欠):
							{{ $addcomma(iouObj.payBackBreakPrice) }}
						</p>
					</div>
					<div v-for="(detail, id) in iouObj.detail" :key="id">
						<table class="table table-bordered mb-0">
							<thead class="grey lighten-4">
								<tr>
									<th colspan="3">
										<h3>
											<strong
												>第{{ detail.stage }}期</strong
											>
										</h3>
									</th>
								</tr>
							</thead>
							<thead class="grey lighten-4">
								<tr>
									<th>應還項目</th>
									<th>應還金額</th>
									<th>金額細節</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>應還本金</td>
									<td>
										{{ $addcomma(detail.stageLoanPay) }}
									</td>
									<td></td>
								</tr>
								<tr>
									<td>應還利息</td>
									<td>
										{{ $addcomma(detail.stageInterest) }}
									</td>
									<td style="overflow-x: scroll">
										<p
											style="
												white-space: nowrap;
												width: 150px;
											"
										>
											{{
												renderCauculateString(
													detail.interestRateDetail,
													detail.paymentType
												)
											}}
										</p>
									</td>
								</tr>
								<tr>
									<td>應還違約金</td>
									<td>{{ $addcomma(detail.breakPrice) }}</td>
									<td style="overflow-x: scroll">
										<p
											style="
												white-space: nowrap;
												width: 150px;
											"
										>
											{{
												renderCauculateString(
													detail.breakPriceDetail,
													1,
													true
												)
											}}
										</p>
									</td>
								</tr>
								<tr>
									<td>總計</td>
									<td>
										{{ $addcomma(detail.stagePayBack) }}
									</td>
									<td></td>
								</tr>
							</tbody>
						</table>
					</div>
				</el-dialog>
				<!-- 列印 -->
				<el-dialog
					:visible.sync="dialogPrint"
					:modal-append-to-body="false"
					:append-to-body="true"
				>
					<el-form label-position="left" label-width="100px">
						<el-form-item label="傳票日期">{{
							$transferDate(currentPrint[0].main.voucherDate)
						}}</el-form-item>
						<el-form-item label="傳票號碼">
							<span>{{ currentPrint[0].main.voucherCode }}</span>
							<span
								v-for="(print, idx) of currentPrint"
								v-if="idx > 0"
							>
								, {{ print.main.voucherCode }}</span
							>
						</el-form-item>
					</el-form>
					<el-button type="primary" plain @click="print"
						>PDF 列印</el-button
					>
					<el-button
						type="primary"
						plain
						@click="
							overPrint(currentPrint[currentPeintIndex].main.id)
						"
						>點陣印表機 套印</el-button
					>
					<div slot="footer" class="dialog-footer"></div>
				</el-dialog>
				<!-- 下一筆列印 -->
				<el-dialog
					:visible.sync="dialogPrintNext"
					:modal-append-to-body="false"
					:append-to-body="true"
				>
					<div class="center" style="font-size: 18px">
						請放入下一張收款單
					</div>
					<div class="center">
						<el-button
							class="mt10"
							type="primary"
							plain
							@click="
								overPrint(
									currentPrint[currentPeintIndex].main.id
								)
							"
							>點陣印表機 套印</el-button
						>
					</div>
					<div slot="footer" class="dialog-footer"></div>
				</el-dialog>
			</div>
			<div class="col-block" v-if="this.$route.query.title === 'report'">
				<div class="block-header has-border">
					<h3>
						<strong>
							{{ memberMain.account + " " + memberMain.name }}
						</strong>
					</h3>

					<br />
					<h3>
						<strong>現金收款作業</strong>
					</h3>
				</div>
				<div class="block-content">
					<div class="show-container">
						<div class="show"></div>
					</div>
					<h3 v-if="iframeshow === true" class="mb-2">
						共 {{ voucher.length }} 張 收款單 金額總計：{{
							allMemberTotalPayment()
						}}
					</h3>
					<br />
					<el-button type="primary" plain @click="backToloan"
						>返回</el-button
					>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { API } from "@/assets/config";
import ListForm from "@/components/ListForm.vue";

export default {
	name: "cabinet_cash",
	components: { ListForm },
	data() {
		return {
			//判斷是否過濾使用者群組 todo
			isFilterGroup: false,
			loanRowIndex: "",
			loanIouNumber: "",
			id: this.$route.params.id,
			inputDsabled: false,
			showSelect: false,
			today: "",
			memberFilter: {
				isFormal: "",
				memberGroupId: 0,
			},
			works: [],
			worksMemberDetail: {
				account: "",
				id: "",
				name: "",
				// 社員本身 需必填
				need: false,
				date: new Date(),
				content: [],
				Repayment: [],
				remark: "",
				amount: "",
				loanIouNumber: "",
				isFormal: "",
				Glossary: "",
			},
			value: "",
			yearList: [],
			GlossaryList: [],
			otherItem: [], //其他會計科目全部
			iframeshow: false,
			reportIdList: [],
			dialogAddWork: false,
			dialogAddItem: false,
			currentAddItem: {},
			// 將新增款項重製
			defaultAddItem: {
				memberId: 0,
				chooseRepayment: "",
				amount: 0,
				type: 0,
				note: "",
				iouObj: {},
				name: "",
				display: true,
				rowspan: 1,
				isRepayment: false,
				Summary: "",
				sixYearData: [],
				iouList: [],
				iouenumData: [],
				currentOtherItem: {},
				selectYear: "",
			},
			currentIndex: 0,

			//收款單主要人員
			memberMain: {},
			addMemberObj: {
				memberType: "",
			},
			// 選擇社員
			options: [],
			originType: [],
			tableData: [
				{
					title: "應還本金",
					price: 0,
				},
				{
					title: "應還利息",
					price: 0,
				},
				{
					title: "應還違約金",
					price: 0,
				},
				{
					title: "總計",
					price: 0,
				},
			],
			iouObj: {},
			loanModal: false,
			accountTitleEnum: {},
			formType: [
				{
					label: "收款對象",
					key: "memberType",
					type: "radio",
					options: [
						{
							label: "社員",
							value: 1,
						},
						{
							label: "準社員",
							value: 0,
						},
					],
				},
				{
					label: "帳號",
					key: "chooseMember",
					type: "chooseMember",
					filter: "",
				},
			],
			// 列印
			dialogPrint: false,
			currentPrint: [
				{
					main: {
						voucherDate: "",
						voucherCode: "",
					},
				},
			],
			base64: [],
			dialogPrintNext: false,
			currentPeintIndex: 0,
		};
	},
	created() {
		this.getData();
		this.setYearList();
	},
	computed: {
		list() {
			return this.works.map((item, mainKey) => {
				let data = {
					// ...item,
					memberId: item.id,
					tradeDate: this.today || "",
					note: item.remark || "",
					detail: [],
				};

				data.detail = item.content.map((items, index) => {
					if (items.type == 2) {
						return {
							...items,
							creditAmount: items.payamount
								.toString()
								.replace(/,/g, ""),
							amount: items.amount.toString().replace(/,/g, ""),
						};
					} else {
						return {
							...items,
							creditAmount: items.amount
								.toString()
								.replace(/,/g, ""),
							amount: items.amount.toString().replace(/,/g, ""),
						};
					}
				});
				return data;
			});
		},
	},
	watch: {
		"addMemberObj.memberType": {
			handler(key) {
				this.formType[1].filter = {
					isFormal: key,
				};

				if (this.isFilterGroup) {
					this.formType[1].filter.memberGroupId =
						this.memberMain.memberGroupId;
				}
			},
			deep: true,
		},
		dialogPrint(newVal, oldVal) {
			// 關閉提示框時，返回社員首頁
			if (oldVal === true && newVal === false && !this.dialogPrintNext) {
				this.$router.push({
					name: "cabinet_edit",
					params: { id: this.id },
				});
			}
		},
	},
	methods: {
		removeMember(workIndex) {
			this.works.splice(workIndex, 1);
		},
		test(amount, workIndex, index) {
			let amountCalculate = parseInt(this.$removeComma(amount));

			for (let i = index + 2; i >= index && amountCalculate > 0; i--) {
				let rowChange = this.works[workIndex].content[i];
				let tmpPayAmount =
					amountCalculate <= rowChange.addamount || i == index
						? amountCalculate
						: rowChange.addamount;
				rowChange.payamount = tmpPayAmount;
				amountCalculate -= tmpPayAmount;
			}
		},
		createAddItem(memberId) {
			let result = JSON.parse(JSON.stringify(this.defaultAddItem));
			result.memberId = memberId;
			return result;
		},
		openAddItem(work, workIndex) {
			this.options = [];
			this.currentAddItem = this.createAddItem(work.id);
			this.inputDsabled = false;
			if (work.isFormal == 0) {
				this.currentAddItem.type = 9;
				this.options = this.originType.filter((item) => {
					if (item.isform == "0") {
						item.label = `${item.code || ""} ${item.name}`;
						item.value = item.accountKey;
						item.options = [];
						return item;
					}
				});
			} else {
				this.options = this.originType.filter((item) => {
					this.currentAddItem.type = 0;
					if (item.isform == "1") {
						item.label = `${item.code || ""} ${item.name}`;
						item.value = item.accountKey;
						item.options = [];
						return item;
					}
				});
			}
			if (this.works[workIndex].date) {
				this.dialogAddItem = true;
				this.currentIndex = workIndex;
			} else {
				this.$message.closeAll();
				this.$message({
					type: "warning",
					message: "請選擇收款日期",
				});
			}
		},
		getAccountTitle() {
			const url = API.coopAccountTitle;
			return this.$http.get(url);
		},
		getMemberObjectByMemberInfo(memberInfo, isNeed = false) {
			var result = JSON.parse(JSON.stringify(this.worksMemberDetail));
			result.account = memberInfo.account;
			result.name = memberInfo.name;
			result.id = memberInfo.id;
			result.isFormal = memberInfo.isFormal;
			result.need = isNeed;
			return result;
		},
		async getData() {
			try {
				// 1. 平行發送請求
				const [dateResp, memberResp, accountResp, glossaryResp] = await Promise.all([
					this.getTodayDate(),
					this.getMemberById(this.id),
					this.getAccountTitleItem(),
					this.getGlossary()
				]);
				
				// 2. 載入日期資料
				this.today = dateResp.resultData;

				// 3. 載入社員資料
				const memberData = memberResp.resultData.data;
				this.memberMain = memberData;

				// 4. 載入會計科目
				const accountData = accountResp.resultData;
				this.originType = accountData;
				this.accountTitleEnum = accountData;

				// 5. 載入中文詞彙
				this.GlossaryList = glossaryResp.resultData.data.map((item) => {
					return {
						label: item.code,
						value: item.content,
					};
				});

				// 6. 資料載入完成，開始執行初始化
				this.works.push(
					this.getMemberObjectByMemberInfo(memberData)
				);
				this.autoAddMemberInfo(this.works.length - 1);
				this.initDatepicker(this.today);
			} catch (error) {
				this.getErrorHandler(error);
				console.error("Initialization failed", error);
			}
		},		
		async getMemberById(id) {
			const url = API.member + `?id=${id}&action=ActionGetMemberSimple`;
			try {
                return await this.mAxiosGet(url);
            } catch (error) {
                console.error("getMemberById failed");
				throw error;
            }
        },
		async getTodayDate() {
			const url = API.coopVoucher + `?action=getTodayDate`;
            try {
                return await this.mAxiosGet(url);
            } catch (error) {
                console.error("getTodayDate failed");
				throw error;
            }
        },
		async getAccountTitleItem() {
			const url = API.coopAccountTitle + `?action=getCashReceiptItem`;
            try {
                return await this.mAxiosGet(url);
            } catch (error) {
                console.error("getAccountTitleItem failed");
				throw error;
            }
		},
		async getGlossary() {
			let url = API.coopGlossary;
			try {
                return await this.mAxiosGet(url);
            } catch (error) {
                console.error("getGlossary failed");
				throw error;
            }
		},
		setYearList() {
			let date = new Date();
			let Y = date.getFullYear();
			let YearArr = [];
			for (let i = 0; i < 3; i++) {
				let yearObj = {
					label: String(Y - i - 1911),
					value: Number(Y - i),
				};
				YearArr.push(yearObj);
			}
			this.yearList = YearArr;
		},
		openAddWork() {
			this.dialogAddWork = true;
			this.inputDsabled = false;
		},
		saveAddWork() {
			this.dialogAddWork = false;

			this.works.push(
				this.getMemberObjectByMemberInfo(
					this.addMemberObj.chooseMember,
					true
				)
			);
			this.autoAddMemberInfo(this.works.length - 1);
		},
		getAmount(localAddItem, funcCallBack = null) {
			if (localAddItem.type === 3) {
				localAddItem.amount = this.$addcomma(
					localAddItem.chooseRepayment.noPayAmount
				);

				localAddItem.name = localAddItem.chooseRepayment.label;
				localAddItem.note = localAddItem.chooseRepayment.label;
			}
			if (localAddItem.type === 4) {
				let sixYearData = JSON.parse(localAddItem.chooseRepayment);
				localAddItem.amount = this.$addcomma(
					sixYearData.advAmount + sixYearData.advFeeAmount
				);
			} else if (localAddItem.type === 2) {
				let form = new FormData();
				let urlSelect = API.coopLoanIou + `?action=voucherGetCalByDate`;
				form.append("iouNumber", localAddItem.chooseRepayment);
				form.append("baseDate", this.today);
				let thenCB = (json) => {
					localAddItem.iouObj = json.resultData;
					if (funcCallBack != null) {
						funcCallBack();
					}
				};
				this.mAxiosPost(urlSelect, form, thenCB);
			} else if (localAddItem.type === 5) {
				// 取得呆帳沖銷金額
				localAddItem.iouList.forEach((item) => {
					if (item.id == localAddItem.chooseRepayment) {
						localAddItem.amount = item.iouPrincipalDealAmount;
						localAddItem.currentOtherItem = item;
					}
				});
			} else if (localAddItem.type == 6) {
				// 取得協議前欠金額
				let url =
					API.coopLoanIou +
					`?action=getAgrBackpay&coopLoanIouId=${localAddItem.chooseRepayment}&baseDate=${this.today}`;
				let thenCB = (json) => {
					localAddItem.iouObj = json.resultData.data;
					localAddItem.iouenumData = json.resultData.enumData;

					let sumAmount = 0;

					Object.keys(json.resultData.data).forEach((_key) => {
						let calculateObject = json.resultData.data[_key];
						if (calculateObject.length > 0) {
							sumAmount +=
								calculateObject[calculateObject.length - 1]
									.backPayPriceTotal || 0;
						}
					});

					localAddItem.amount = sumAmount;
					if (funcCallBack != null) {
						funcCallBack();
					}
				};
				this.mAxiosGet(url, thenCB);
			} else if (localAddItem.type == 7) {
				let urlSelect =
					API.member +
					`?action=ActionGetMemberAnnualCost&id=${localAddItem.memberId}&year=${localAddItem.selectYear}`;
				let thenCB = (json) => {
					localAddItem.amount = this.$addcomma(json.resultData.data);
					localAddItem.iouObj =
						json.resultData.enumData.annualAccountTitle;
					if (funcCallBack != null) {
						funcCallBack();
					}
				};
				this.mAxiosGet(urlSelect, thenCB);

				// let url ?action=&id={memberId}&year={year}
			} else if (localAddItem.type === 8) {
				this.otherItem.filter((item) => {
					if (item.id == localAddItem.chooseRepayment) {
						localAddItem.currentOtherItem = item;
					}
				});
			}

			if (
				funcCallBack != null &&
				localAddItem.type != 7 &&
				localAddItem.type != 2 &&
				localAddItem.type != 6
			) {
				funcCallBack();
			}
		},
		calculateIouAmountPay(amount, iouInfo) {
			let objectKeyMap = {
				ld: iouInfo.payBackBreakPrice,
				interest: iouInfo.payBackInterest,
				capital: iouInfo.payBackLoanPrice,
			};

			let result = {};

			["ld", "interest", "capital"].forEach((key) => {
				if (amount > 0) {
					let payAmount =
						objectKeyMap[key] < amount ? objectKeyMap[key] : amount;
					result[key] = payAmount;
					amount -= payAmount;
				} else {
					result[key] = 0;
				}
			});

			return result;
		},
		saveAddItem(localAddItem, currentIndex, isNotAuto = false) {
			if (localAddItem.type == 2) {
				if (
					(!isNotAuto || localAddItem.amount) &&
					localAddItem.chooseRepayment
				) {
					const accountTitle = localAddItem.iouObj.accountTitle;

					let calculatePayResult = this.calculateIouAmountPay(
						this.$removeComma(localAddItem.amount),
						localAddItem.iouObj
					);

					const ioupayBackLoanPrice =
						localAddItem.iouObj.payBackLoanPrice;
					const ioupayBackInterest =
						localAddItem.iouObj.payBackInterest;
					const ioupayBackBreakPrice =
						localAddItem.iouObj.payBackBreakPrice;

					let capitalObj = {
						name: `${accountTitle.capitalAccountTitle.code} ${accountTitle.capitalAccountTitle.name}`,
						accountTitleId: accountTitle.capitalAccountTitle.id,
						accountTitleCode: accountTitle.capitalAccountTitle.code,
						accountTitleName: accountTitle.capitalAccountTitle.name,
						type: 2,
						display: true,
						rowspan: 3,
						loanIouNumber: localAddItem.chooseRepayment || "",
						ioutObj: {
							amount: localAddItem.iouObj.payBackLoanPrice,
						},
						amount: this.$addcomma(localAddItem.amount),
						addamount: localAddItem.iouObj.payBackLoanPrice,
						judegeKey: 2,
						Summary: localAddItem.chooseRepayment
							? `借據號:${localAddItem.chooseRepayment}`
							: "",
						note: `金額: ${ioupayBackLoanPrice || "0"}, 借據號: ${
							localAddItem.chooseRepayment
						}`,
						isRepayment: true,
						payamount: calculatePayResult.capital,
					};
					let interestObj = {
						name: `${accountTitle.interestAccountTitleId.code} ${accountTitle.interestAccountTitleId.name}`,
						accountTitleId: accountTitle.interestAccountTitleId.id,
						accountTitleCode:
							accountTitle.interestAccountTitleId.code,
						accountTitleName:
							accountTitle.interestAccountTitleId.name,
						loanIouNumber: localAddItem.chooseRepayment,
						type: 2,
						display: false,
						rowspan: 1,
						amount: 0,
						addamount: localAddItem.iouObj.payBackInterest,
						Summary: localAddItem.chooseRepayment
							? `借據號:${localAddItem.chooseRepayment}`
							: "",
						note: `金額: ${ioupayBackInterest || "0"}, 借據號: ${
							localAddItem.chooseRepayment
						}`,
						payamount: calculatePayResult.interest,
					};
					let ldObj = {
						name: `${accountTitle.ldAccountTitleId.code} ${accountTitle.ldAccountTitleId.name}`,
						accountTitleId: accountTitle.ldAccountTitleId.id,
						accountTitleCode: accountTitle.ldAccountTitleId.code,
						accountTitleName: accountTitle.ldAccountTitleId.name,
						loanIouNumber: localAddItem.chooseRepayment,
						type: 2,
						display: false,
						rowspan: 1,
						amount: 0,
						addamount: localAddItem.iouObj.payBackBreakPrice, //localAddItem.iouObj
						Summary: localAddItem.chooseRepayment
							? `借據號:${localAddItem.chooseRepayment}`
							: "",
						note: `金額: ${ioupayBackBreakPrice || "0"}, 借據號: ${
							localAddItem.chooseRepayment
						}`,
						payamount: calculatePayResult.ld,
					};
					this.works[currentIndex].content.push(capitalObj);
					this.works[currentIndex].content.push(interestObj);
					this.works[currentIndex].content.push(ldObj);
					this.works[currentIndex].amount = localAddItem.amount;
				} else {
					this.$message.closeAll();
					this.$message({
						type: "warning",
						message: "請選擇方案及輸入金額",
					});
				}
			} else if (localAddItem.type == 3) {
				if (localAddItem.amount && localAddItem.chooseRepayment) {
					const newObj = JSON.parse(JSON.stringify(localAddItem));
					newObj.name = this.accountTitleEnum[newObj.type].name;
					newObj.insPlanApplyNumber =
						localAddItem.chooseRepayment.insPlanMemberApplyId;
					newObj.accountTitleId =
						localAddItem.chooseRepayment.accountTitleId;
					newObj.accountTitleCode =
						localAddItem.chooseRepayment.accountTitleCode;
					newObj.addamount = localAddItem.amount;
					newObj.Summary = this.accountTitleEnum[newObj.type].name;
					newObj.note = localAddItem.note;
					newObj.amount = localAddItem.amount;
					newObj.disabled = true;
					this.works[currentIndex].content.push(newObj);
				} else {
					this.$message.closeAll();
					this.$message({
						type: "warning",
						message: "請選擇方案",
					});
				}
			} else if (localAddItem.type == 4) {
				if (localAddItem.amount) {
					let sixYearData = JSON.parse(localAddItem.chooseRepayment);

					let accountTitleSixYear = {
						name: `${localAddItem.sixYearData.accountTitleSixYear.code} ${localAddItem.sixYearData.accountTitleSixYear.name}`,
						accountTitleId:
							localAddItem.sixYearData.accountTitleSixYear.id,
						accountTitleCode:
							localAddItem.sixYearData.accountTitleSixYear.code,
						accountTitleName:
							localAddItem.sixYearData.accountTitleSixYear.name,
						type: localAddItem.type,
						note: localAddItem.note,
						Summary: localAddItem.note,
						rowspan: 1,
						chooseRepayment: "",
						amount: this.$addcomma(sixYearData.advAmount),
						addamount: this.$addcomma(sixYearData.advAmount),
						display: true,
						insSavingCode: sixYearData.insSavingCode,
					};
					let accountTitleSixYearInterest = {
						name: `${localAddItem.sixYearData.accountTitleSixYearInterest.code} ${localAddItem.sixYearData.accountTitleSixYearInterest.name}`,
						accountTitleId:
							localAddItem.sixYearData.accountTitleSixYearInterest
								.id,
						accountTitleCode:
							localAddItem.sixYearData.accountTitleSixYearInterest
								.code,
						accountTitleName:
							localAddItem.sixYearData.accountTitleSixYearInterest
								.name,
						type: localAddItem.type,
						note: localAddItem.note,
						Summary: localAddItem.note,
						rowspan: 1,
						chooseRepayment: "",
						amount: this.$addcomma(sixYearData.advFeeAmount),
						addamount: this.$addcomma(sixYearData.advFeeAmount),
						display: true,
						insSavingCode: sixYearData.advFeeAmount.insSavingCode,
					};
					this.works[currentIndex].content.push(accountTitleSixYear);
					this.works[currentIndex].content.push(
						accountTitleSixYearInterest
					);
				}
			} else if (localAddItem.type == 5) {
				let obj = localAddItem.currentOtherItem;
				let CreditObj =
					localAddItem.iouenumData.accountTitlePrincipalCredit;
				let GuaranteeObj =
					localAddItem.iouenumData.accountTitlePrincipalGuarantee;
				let pay = localAddItem.iouenumData.accountTitlePay;

				let LoanIouDeadObj = {
					name: `${
						obj.loanType == 1 ? CreditObj.code : GuaranteeObj.code
					} ${
						obj.loanType == 1 ? CreditObj.name : GuaranteeObj.name
					}`,
					accountTitleId:
						obj.loanType == 1 ? CreditObj.id : GuaranteeObj.id,
					accountTitleCode:
						obj.loanType == 1 ? CreditObj.code : GuaranteeObj.code,
					accountTitleName:
						obj.loanType == 1 ? CreditObj.name : GuaranteeObj.name,
					type: localAddItem.type,
					Summary: localAddItem.note,
					loanIouNumber: obj.iouNumber,

					amount: this.$addcomma(obj.iouPrincipalDealAmount),
					addamount: this.$addcomma(obj.iouPrincipalDealAmount),
					note: `金額: ${this.$addcomma(
						obj.iouPrincipalDealAmount
					)}, 借據號: ${obj.iouNumber}`,
					display: true,
				};
				let LoanPayObj = {
					name: `${pay.code} ${pay.name}`,
					accountTitleId: pay.id,
					accountTitleCode: pay.code,
					accountTitleName: pay.name,
					type: localAddItem.type,
					Summary: localAddItem.note,
					loanIouNumber: localAddItem.iouNumber,
					// chooseRepayment: "",
					amount: this.$addcomma(
						obj.iouDefNoPayAmount +
							obj.iouInterNoPayAmount +
							obj.iouLawNoPayAmount
					),
					addamount: this.$addcomma(
						obj.iouDefNoPayAmount +
							obj.iouInterNoPayAmount +
							obj.iouLawNoPayAmount
					),
					note: `金額: ${this.$addcomma(
						obj.iouDefNoPayAmount +
							obj.iouInterNoPayAmount +
							obj.iouLawNoPayAmount
					)}, 借據號: ${obj.iouNumber}`,
					display: true,
				};

				this.works[currentIndex].content.push(LoanIouDeadObj);
				this.works[currentIndex].content.push(LoanPayObj);
			} else if (localAddItem.type == 6) {
				if (!isNotAuto || localAddItem.amount) {
					let accountTitleIou = localAddItem.iouenumData.accountTitle;
					let iouBackPayPrice = localAddItem.iouObj;
					let iouObject = localAddItem.iouenumData.iou;
					let agrObject = localAddItem.iouenumData.agr;
					let accountTitlePriceMap = [
						{
							accountTitleName: "agrBackPayAccountTitle",
							objectName: "otherBackPay",
						},
						{
							accountTitleName: "interestAccountTitleId",
							objectName: "interestBackPay",
						},
						{
							accountTitleName: "ldAccountTitleId",
							objectName: "defBackPay",
						},
					];
					accountTitlePriceMap.forEach((accountTitleMap) => {
						let accountTitleCurrent =
							accountTitleIou[accountTitleMap.accountTitleName];
						let priceItem =
							iouBackPayPrice[accountTitleMap.objectName];

						if (priceItem.length > 0) {
							let finalPriceTotal =
								priceItem[priceItem.length - 1]
									.backPayPriceTotal;

							let accountTitleObject = {
								name: `${accountTitleCurrent.code} ${accountTitleCurrent.name}`,
								accountTitleCode: accountTitleCurrent.code,
								accountTitleName: accountTitleCurrent.name,
								accountTitleId: accountTitleCurrent.id,
								amount: this.$addcomma(finalPriceTotal),
								Summary: `借據號 ${iouObject.iouNumber} 協議 ${agrObject.agreementCode} 前欠金額`,
								note: `借據號 ${iouObject.iouNumber} 協議 ${agrObject.agreementCode} 前欠金額`,
								loanIouNumber: iouObject.iouNumber,
								loanIouAgrCode: agrObject.agreementCode,
								display: true,
							};

							if (finalPriceTotal > 0) {
								this.works[currentIndex].content.push(
									accountTitleObject
								);
							}
						}
					});
				} else {
					this.$message.closeAll();
					this.$message({
						type: "warning",
						message: "無協議前欠",
					});
				}
			} else if (localAddItem.type == 7) {
				if (localAddItem.amount) {
					const newObj = JSON.parse(JSON.stringify(localAddItem));
					newObj.name = `${localAddItem.iouObj.code} ${localAddItem.iouObj.name}`;
					newObj.accountTitleCode = localAddItem.iouObj.code;
					newObj.accountTitleName = localAddItem.iouObj.name;
					newObj.accountTitleId = localAddItem.iouObj.id;
					newObj.amount = localAddItem.amount;
					newObj.annualCostYear = localAddItem.selectYear;
					newObj.Summary = localAddItem.note;
					newObj.note = localAddItem.note;
					newObj.disabled = true;
					this.works[currentIndex].content.push(newObj);
				} else {
					this.$message.closeAll();
					this.$message({
						type: "warning",
						message: "請選擇年度(金額自動帶出)",
					});
				}
			} else if (localAddItem.type == 8) {
				if (
					(!isNotAuto || localAddItem.amount) &&
					localAddItem.chooseRepayment
				) {
					const newObj = JSON.parse(JSON.stringify(localAddItem));
					newObj.name = `${localAddItem.currentOtherItem.code} ${localAddItem.currentOtherItem.name}`;

					newObj.accountTitleCode =
						localAddItem.currentOtherItem.code;
					newObj.accountTitleName =
						localAddItem.currentOtherItem.name;
					newObj.accountTitleId = localAddItem.currentOtherItem.id;
					newObj.realAmount = this.$addcomma(newObj.amount);
					newObj.amount = this.$addcomma(newObj.amount);
					newObj.Summary = localAddItem.note;
					newObj.note = localAddItem.note;
					this.works[currentIndex].content.push(newObj);

					localAddItem = this.defaultAddItem;
				} else {
					this.$message.closeAll();
					this.$message({
						type: "warning",
						message: "請選擇會計科目並輸入金額",
					});
				}
			} else if (localAddItem.type == 9) {
				if (!isNotAuto || localAddItem.amount) {
					const newObj = JSON.parse(JSON.stringify(localAddItem));
					newObj.name =
						this.accountTitleEnum[newObj.type].code +
						" " +
						this.accountTitleEnum[newObj.type].name;
					newObj.accountTitleCode =
						this.accountTitleEnum[newObj.type].code;
					newObj.accountTitleName =
						this.accountTitleEnum[newObj.type].name;
					newObj.accountTitleId =
						this.accountTitleEnum[newObj.type].id;
					newObj.addamount = this.$addcomma(localAddItem.amount);
					newObj.Summary = localAddItem.note;
					newObj.note = localAddItem.note;
					newObj.amount = this.$addcomma(localAddItem.amount);
					newObj.realAmount = this.$addcomma(newObj.amount);
					this.works[currentIndex].content.push(newObj);

					localAddItem = this.defaultAddItem;
				} else {
					this.$message.closeAll();
					this.$message({
						type: "warning",
						message: "請輸入金額",
					});
				}
			} else {
				if (!isNotAuto || localAddItem.amount) {
					const newObj = JSON.parse(JSON.stringify(localAddItem));
					newObj.name =
						this.accountTitleEnum[newObj.type].code +
						" " +
						this.accountTitleEnum[newObj.type].name;
					newObj.accountTitleCode =
						this.accountTitleEnum[newObj.type].code;
					newObj.accountTitleName =
						this.accountTitleEnum[newObj.type].name;
					newObj.accountTitleId =
						this.accountTitleEnum[newObj.type].id;
					newObj.addamount = this.$addcomma(localAddItem.amount);
					newObj.Summary = localAddItem.note;
					newObj.note = localAddItem.note;
					newObj.realAmount = this.$addcomma(newObj.amount);
					newObj.amount = this.$addcomma(localAddItem.amount);
					this.works[currentIndex].content.push(newObj);

					localAddItem = this.defaultAddItem;
				} else {
					this.$message.closeAll();
					this.$message({
						type: "warning",
						message: "請輸入金額",
					});
				}
			}
			if (isNotAuto) {
				this.dialogAddItem = false;
				this.showSelect = false;
			}
		},
		chooseType(
			localAddItem,
			currentIndex,
			funcCallBack,
			isChangeUi = false
		) {
			let urlSelect = "";
			let thenCB = null;
			let key = localAddItem.memberId;
			localAddItem.iouList = [];
			localAddItem.chooseRepayment = "";
			localAddItem.amount = 0;

			if (isChangeUi) {
				this.showSelect = false;
				this.inputDsabled = false;
			}

			switch (localAddItem.type) {
				// 撈取股金列表
				case 0:
					urlSelect = "";
					if (funcCallBack != null) {
						funcCallBack();
					}
					break;
				// 撈取備轉金列表
				case 1:
					urlSelect = "";
					if (funcCallBack != null) {
						funcCallBack();
					}
					break;
				// 撈取借據列表
				case 2:
					urlSelect =
						API.coopLoanIou +
						`?action=getListByMember&memberId=${key}&paymentType=1`; //${this.works[this.currentIndex].id}
					thenCB = (json) => {
						localAddItem.iouList = json.resultData;
						if (isChangeUi) {
							this.showSelect = true;
						}
						if (funcCallBack != null) {
							funcCallBack();
						}
					};
					this.mAxiosGet(urlSelect, thenCB);

					break;
				// 撈取代辦互助基金列表
				case 3:
					urlSelect =
						API.coopInsPlanMember +
						`?action=getInsPlanByMember&memberId=${key}`;
					thenCB = (json) => {
						localAddItem.iouList = json.resultData.map((item) => {
							return {
								value: item.insPlanMainCode,
								label: item.insPlanMainName,
								noPayAmount: item.diffAmount,
								insPlanApplyNumber: item.insPlanMainCode,
								accountTitleId: item.colAccountTitle.id,
								accountTitleCode: item.colAccountTitle.code,
								insPlanMemberApplyId: item.insPlanMemberApplyId,
							};
						});
						if (isChangeUi) {
							this.showSelect = true;
							this.inputDsabled = true;
						}
						if (funcCallBack != null) {
							funcCallBack();
						}
					};
					this.mAxiosGet(urlSelect, thenCB);

					break;
				// 撈取六年平儲列表
				case 4:
					urlSelect =
						API.coopInsSavingApply +
						`?action=getMemberNotEnd&memberId=${key}`;
					thenCB = (json) => {
						localAddItem.sixYearData = json.resultData.enumData;
						localAddItem.iouList = json.resultData.data.map(
							(item) => {
								return {
									label: item.insSavingCode,
									value: JSON.stringify(item),
									accountTitleSixYear: {
										label: `${json.resultData.enumData.accountTitleSixYear.code} ${json.resultData.enumData.accountTitleSixYear.name}`,
										value: json.resultData.enumData
											.accountTitleSixYear.id,
										amount: item.advAmount,
									},
									accountTitleSixYearInterest: {
										label: `${json.resultData.enumData.accountTitleSixYearInterest.code} ${json.resultData.enumData.accountTitleSixYearInterest.name}`,
										value: json.resultData.enumData
											.accountTitleSixYearInterest.id,
										amount: item.advFeeAmount,
									},
								};
							}
						);
						if (isChangeUi) {
							this.showSelect = true;
							this.inputDsabled = true;
						}
						if (funcCallBack != null) {
							funcCallBack();
						}
					};
					this.mAxiosGet(urlSelect, thenCB);

					break;
				//呆帳轉銷後收回
				case 5:
					urlSelect =
						API.coopLoanIouDead +
						`?action=getMemberIouDeadList&memberId=${key}`;
					thenCB = (json) => {
						localAddItem.iouenumData = json.resultData.enumData;
						localAddItem.iouList = json.resultData.data.map(
							(item) => {
								return {
									...item,
									label: item.iouNumber,
									value: item.id,
								};
							}
						);
						if (isChangeUi) {
							this.showSelect = true;
						}
						if (funcCallBack != null) {
							funcCallBack();
						}
					};
					this.mAxiosGet(urlSelect, thenCB);

					break;
				//撈取前欠列表;
				case 6:
					urlSelect =
						API.coopLoanIou +
						`?action=getMemberAgrBackpayNotPay&memberId=${key}`;
					thenCB = (json) => {
						localAddItem.iouList = json.resultData.data.map(
							(iouAgr) => {
								return {
									label: iouAgr.coopLoanIouNumber,
									value: iouAgr.coopLoanIouId,
								};
							}
						);

						if (isChangeUi) {
							this.inputDsabled = true;
							this.showSelect = true;
						}
						if (funcCallBack != null) {
							funcCallBack();
						}
					};
					this.mAxiosGet(urlSelect, thenCB);

					break;
				//社員年費金額輸入disabled;
				case 7:
					if (isChangeUi) {
						this.inputDsabled = true;
					}
					if (funcCallBack != null) {
						funcCallBack();
					}
					break;
				// 撈取其他列表
				case 8:
					urlSelect =
						API.coopAccountTitle +
						`?action=getByCashReceipt&memberId=${key}`;
					thenCB = (json) => {
						this.otherItem = json.resultData;
						localAddItem.iouList = json.resultData.map((item) => {
							return {
								label: `${item.code} ${item.name}`,
								value: item.id,
								code: item.code,
								name: item.name,
							};
						});
						if (isChangeUi) {
							this.showSelect = true;
						}
						if (funcCallBack != null) {
							funcCallBack();
						}
					};
					this.mAxiosGet(urlSelect, thenCB);

					break;
				default:
					urlSelect = "";
					if (funcCallBack != null) {
						funcCallBack();
					}
			}
		},
		initDatepicker(date) {
			const rocDate = this.$transferDate(date);
			this.$nextTick(() => {
				const $el = $(`.min_go_date_select`);
				$el.val(rocDate);
				$el.datepicker({
					changeYear: true,
					changeMonth: true,
					currentText: "今天",
					dateFormat: "Rmmdd",
					showButtonPanel: true,
					defaultDate: null,
					onSelect: (data) => {
						let dateArray = data.split("-");
						this.today = `${parseInt(dateArray[0]) + 1911}-${
							dateArray[1]
						}-${dateArray[2]}`;
						this.refreshAll();
					},
				});
			});
		},
		//刷新全部
		refreshAll() {
			for (let i = 0; i < this.works.length; i++) {
				this.refreshItem(i);
			}
		},
		//刷新單一筆
		refreshItem(currentIndex) {
			this.works[currentIndex].content = [];
			this.autoAddMemberInfo(currentIndex);
		},
		//模仿使用者操作自動產生
		autoAddMemberInfo(currentIndex) {
			let workColumns = this.works[currentIndex];

			let autoRunItem =
				workColumns.isFormal == 1 ? [0, 1, 2, 3, 4, 5, 6, 7] : [9];

			autoRunItem.forEach((itemKey) => {
				//Step 1 mock 一個currentAddItem
				let mockAddItem = this.createAddItem(workColumns.id);

				//Step 2 使用者選擇類型
				mockAddItem.type = itemKey;
				//Step 3 取得要委派的function
				let invokeFunc = this.getAutoFuncByType(
					itemKey,
					mockAddItem,
					currentIndex
				);
				//Step 4 觸發select 的onchange 事件
				this.chooseType(mockAddItem, currentIndex, invokeFunc);
			});
		},
		getAutoFuncByType(type, mockAddItem, currentIndex) {
			switch (type) {
				case 0:
				case 1:
				case 9:
					return () => {
						this.saveAddItem(mockAddItem, currentIndex);
					};
				case 2:
				case 3:
				case 4:
				case 5:
				case 6:
					return () => {
							mockAddItem.iouList.forEach((rowSelect) => {
							let mockObjectCopy = JSON.parse(
								JSON.stringify(mockAddItem)
							);
							mockObjectCopy.chooseRepayment =
								this.getRowSelectValue(type, rowSelect);

							this.getAmount(mockObjectCopy, () => {
								this.saveAddItem(mockObjectCopy, currentIndex);
							});
						});
					};
				case 7:
					return () => {
							let year = new Date().getFullYear();
							mockAddItem.selectYear = year;
							this.getAmount(mockAddItem, () => {
								this.saveAddItem(mockAddItem, currentIndex);
							});
					};
			}
		},
		getRowSelectValue(type, rowSelect) {
			switch (type) {
				case 2:
					return rowSelect.iouNumber;
				case 3:
					return rowSelect;
				case 5:
					return `${rowSelect.value}`;
				default:
					return rowSelect.value;
			}
		},
		totalPayment(work) {
			let total = 0;
			work.content.map((item) => {
				if (item.amount) {
					total += parseInt(item.amount.toString().replace(/,/g, ""));
				}
			});
			return this.$addcomma(total);
		},
		allMemberTotalPayment() {
			let total = 0;
			this.works.map((work) => {
				work.content.map((item) => {
					if (item.amount) {
						total += parseInt(
							item.amount.toString().replace(/,/g, "")
						);
					}
				});
			});
			return this.$addcomma(total);
		},
		go(name) {
			this.$router.push({ name: name });
		},
		back() {
			this.$router.push({
				name: "cabinet_edit",
				params: {
					id: this.id,
				},
			});
		},
		backToloan() {
			this.$router.push({
				name: "cabinet_printReport",
				query: {
					title: "",
				},
			});
		},
		removeItem(workIndex, itemIndex, isRepayment = false) {
			let sliceCount = 1;
			if (isRepayment) {
				sliceCount = 3;
			}
			this.works[workIndex].content.splice(itemIndex, sliceCount);
		},
		resetDate(workIndex, itemIndex) {
			this.showRepaymentInfo(workIndex, itemIndex);
		},
		showRepaymentInfo(workIndex, rowIndex) {
			$(".min_go_date").datepicker({
				changeYear: true,
				changeMonth: true,
				currentText: "今天",
				dateFormat: "Rmmdd",
				showButtonPanel: true,
			});
			const form = new FormData();
			const url = API.coopLoanIou + "?action=getCalByDate";
			const thenCB = (json) => {
				this.iouObj = json.resultData;
				this.handleTableData(json.resultData);
				this.loanModal = true;
				this.loanIouNumber =
					this.works[workIndex].content[rowIndex].loanIouNumber;
				this.loanRowIndex = rowIndex;
			};

			if ($(".changeDate").val() !== "") {
				let date =
					parseInt($(".changeDate").val().split("-")[0]) +
					1911 +
					$(".changeDate").val().slice(3);
				form.append("baseDate", date);
			} else {
				form.append("baseDate", this.today);
			}

			form.append(
				"iouNumber",
				this.works[workIndex].content[rowIndex].loanIouNumber
			);

			this.mAxiosPost(url, form, thenCB);
		},
		handleTableData(resultData) {
			this.tableData[0].price = resultData.payBackLoanPrice;
			this.tableData[1].price = resultData.payBackInterest;
			this.tableData[2].price = resultData.payBackBreakPrice;
			this.tableData[3].price =
				resultData.payBackLoanPrice +
				resultData.payBackInterest +
				resultData.payBackBreakPrice;
		},
		submit() {
			let isSubmitForm = false;
			isSubmitForm = this.list.some((item) => {
				if (item.detail.length === 0) {
					this.$message.closeAll();
					this.$message({
						type: "warning",
						message: "收款項目不可為空",
					});
					return true;
				}
			});
			if (isSubmitForm == false) {
				this.submitSend();
			}
		},
		async submitSend() {
			const url = API.counterWork + "?action=voucherSubmit";
			const form = new FormData();
			form.append("data", JSON.stringify(this.list));
			try {
				const json = await this.mAxiosPost(url, form);

				this.$message.closeAll();
				this.$message({
					type: "success",
					message: "已開立傳票",
				});
				this.openDialog(json.resultData);
			} catch (error) {
                console.error("Submit operation failed.");
			}
		},
		renderCauculateString(
			interestRateDetail,
			paymentType,
			isBreakPrice = false
		) {
			let result = "";
			interestRateDetail.forEach((rateDetail) => {
				let date = {
					beginDate: this.$transferDate(rateDetail.beginDate),
					endDate: this.$transferDate(rateDetail.endDate),
				};
				let dateDiff = rateDetail.dateDiff;
				let interestRate = rateDetail.interestRate;
				let interest =
					paymentType == 2
						? rateDetail.interestMonthly
						: rateDetail.interestDaily;
				let loanPrice = rateDetail.loanPrice;
				result += `${date["beginDate"]} ~ ${
					date["endDate"]
				} ${dateDiff}天 ${
					isBreakPrice ? "利息" : "本金"
				}${this.$addcomma(
					loanPrice || "0"
				)}元 年利率 ${interestRate}% 共 ${this.$addcomma(
					interest || "0"
				)} 元 `;
			});

			return result;
		},

		importGlossary(index) {
			if (!this.works[index].Glossary) {
				this.$message.closeAll();
				this.$message({
					type: "warning",
					message: "請先選擇詞彙",
				});
			} else {
				if (this.works[index].remark == "") {
					this.$nextTick(() => {
						this.works[index].remark = this.works[index].Glossary;
					});
				} else {
					this.$nextTick(() => {
						this.works[
							index
						].remark += `,${this.works[index].Glossary}`;
					});
				}
			}
		},
		resetAmount(amount, workIndex, itemIndex) {
			this.works[workIndex].content[itemIndex].amount = this.$addcomma(
				this.$removeComma(amount)
			);
		},
		resetAddAmount(amount) {
			return (this.currentAddItem.amount = this.$addcomma(
				this.$removeComma(amount)
			));
		},
		openDialog(main) {
			this.dialogPrint = true;
			this.currentPrint = main;
		},
		print() {
			this.$router.push({
				name: "cabinet_printReport",
				params: {
					Num: this.currentPrint,
				},
			});
		},
		overPrint(id) {
			if (this.currentPrint.length > this.currentPeintIndex) {
				// 有下一張收款單
				this.dialogPrintNext = true;
				this.currentPeintIndex += 1;
			}
			const url = API.coopVoucher + `?id=${id}&action=overprint`;
			const thenCB = (json) => {
				this.base64 = [
					{
						data: json.resultData,
					},
				];
				setTimeout(() => {
					this.printReport();
				}, 0);
			};

			this.mAxiosGet(url, thenCB);
		},
		printReport() {
			const url = "http://localhost:4330/transfer/print";
			// delete this.$http.defaults.headers.common["X-Jesda-Api-Key"];
			const form = new FormData();
			const vm = this;
			let data = this.base64;
			let length = data.length;
			if (length == 1) {
				form.append("test", JSON.stringify(this.base64[0].data));

				let thenCB = (result) => {
					if (result == "") {
						this.$message({
							type: "success",
							message: "成功",
						});
					} else {
						this.$message({
							type: "error",
							message: result.errorMessage,
						});
					}
				};

				fetch(url, { method: "post", body: form })
					.then((data) => (data.status != 200 ? data.json() : ""))
					.then((result) => thenCB(result));

				this.base64.splice(0, 1);
			} else if (length > 1) {
				form.append("test", JSON.stringify(this.base64[0].data));
				this.$alert("繼續列印", "提示", {
					dangerouslyUseHTMLString: true,
					confirmButtonText: "繼續列印",
					type: "warning",
					showClose: false,
				}).then(() => {
					this.continuePrint();
				});

				let thenCB = (result) => {
					if (result == "") {
						this.$message({
							type: "success",
							message: "成功",
						});
					} else {
						this.$message({
							type: "error",
							message: result.errorMessage,
						});
					}
				};

				fetch(url, { method: "post", body: form })
					.then((data) => (data.status != 200 ? data.json() : ""))
					.then((result) => thenCB(result));
				this.base64.splice(0, 1);
			}
		},
		continuePrint() {
			//判斷目前的長度有資料再去post
			let data = this.base64;
			if (data.length > 0) {
				this.printReport();
			}
		},
	},
};
</script>
<style lang="scss" scoped>
.mr5 {
	margin-right: 5px;
}
.fs15 {
	font-size: 15px;
}
.fx-box {
	position: relative;
	.el-icon-date {
		vertical-align: top;
	}
}
.min_go_date_select {
	border-radius: 4px;
	border: 1px solid #dcdfe6;
	height: 40px;
	line-height: 40px;
	width: 220px;
	padding-left: 30px;
	color: #606266;
}
.date {
	font-size: 14px;
	display: inline-block;
	position: relative;
	margin-bottom: 10px;
	span {
		margin-top: 10px;
	}
}
.block-content {
	.box-card {
		margin-bottom: 10px;

		&:last-child {
			margin-bottom: 0;
		}

		.table {
			td {
				vertical-align: middle;
			}
		}
	}
}
</style>
